module.exports = "/assets/data/75904fee7fd5e148f848d9dfebaf3562-G2.data.json";